import React, { useCallback,Component,Fragment,useEffect,useState } from "react";
import FileSaver from "file-saver";
import { useCurrentPng } from "recharts-to-png";
import { bindActionCreators } from "redux";
import { connect , useSelector } from "react-redux";
import toastr from "toastr";
import * as R from 'ramda';
import moment from "moment";
import { Card, CardHeader,CardTitle,CardBody } from "reactstrap";
import { MapWithAMarkerClusterer } from "../../common/maps/Maps";
import TextFieldGroup from "../../common/TextFieldGroup";
import Select from "react-select-nested-group";
import Things from "../../../ducks/Things";
import Groups from "../../../ducks/Groups";
import ReactSpeedometer from "react-d3-speedometer";
import DateTime from 'react-datetime';
import { Spinner } from '../../common/Spinner';
import "./index.css";

import {
  LineChart,
  ResponsiveContainer,
  BarChart, Bar,
  XAxis,
  ReferenceLine,
  Legend,
  CartesianGrid,
  YAxis,
  Tooltip,
  Line
} from "recharts";

  const Temperature = props => {

    const filters = [
      { value: "company", label: "Company" },
      { value : "idividual" , label : "Individual Thing"}
    ];

    const companyInfo = JSON.parse(localStorage.getItem("companyInfo"));
    const [companyId, setCompanyId] = useState(companyInfo ? companyInfo.companyId : "");
    const [getTemperaturePng, { ref: temperatureRef }] = useCurrentPng();
    const [getHumidityPng, { ref: humidityRef }] = useCurrentPng();
    const [things, setThings] = useState([]);
    const [selectedThing, setSelectedThing] = useState('');
    const [selectedStartDate, setSelectedStartDate] = useState(moment());
    const [selectedEndDate, setSelectedEndDate] = useState(moment());
    const [selectedFilter , setSelectedFilter] = useState(filters[0]);
    const [screenDisplay, setScreenDisplay] = useState('company');
    const [isloader, setIsloader] = useState(false);
    const [selectedData, setSelectedData] = useState({});
    const [mapthing, setMapthing] = useState({});
    const [initloading, setInitoading] = useState(true);
    const group = useSelector( state => state?.groups?.group);
    const temperature = useSelector( state => state?.things?.TemperaturesData);
    const thingsData = useSelector( state => state?.things?.groupVehicles);
    const storeSelectedThing = useSelector( state => state?.things?.selectedThing);
    const SingleTemperatureData = useSelector( state => state?.things?.SingleTemperatureData);

    useEffect(() => {
      loadThings();
    },[]);

    const loadThings = async () => {
      let companyInfo = JSON.parse(localStorage.getItem("companyInfo"));
      await props.actions.getGroupVehicles({ groupId:  companyInfo.groupId });
      await props.groupActions.getSingleToUpdate(companyInfo.groupId);
    };

    const  handleRouterChange = (option) => {
      setSelectedThing(option);
    };
    const handleTemperatureDownload = useCallback(async () => {
      const png = await getTemperaturePng();
      if (png) {
        FileSaver.saveAs(png, "temperature-chart.png");
      }
    }, [getTemperaturePng]);

    const handleHumidityDownload = useCallback(async () => {
      const png = await getHumidityPng();
      if (png) {
        FileSaver.saveAs(png, "humidity-chart.png");
      }
    }, [getHumidityPng]);

    const  onSubmit = async (option) => {
        let startDate = selectedStartDate['_d'];
        let endDate = selectedEndDate['_d'];

        let diff = endDate - startDate;
        let finalDiff = Math.ceil(diff/ (1000 * 60 * 60));
        if (finalDiff > 24 ) {
          return toastr.error("Duration Should be 1 Day Maximum");
        };
        setIsloader(true);
        let imei = props.match.params.id;
        let requestData = {
          imei,
          interval:JSON.stringify({
            interval:{
              startDate :  moment(startDate),
              endDate :  moment(endDate)
            }
          })
        };
        let response = await props.actions.getDatabasedonSingleImei(requestData);
        console.log("------105----response-------",response)
        if (response){
          setSelectedData(response)
          let mapthing = {
            '_id':response._id,
            'lat':response.lastLat,
            'lng':response.lastLng,
            'temperature':response.lastTemp,
            'timestamp':response.timestamp,
            'humidity':response.lastHum,
            'imei':response.imei,
            'name':response.name
          };
          setMapthing(mapthing);
        } else {
          setSelectedData({})
          setMapthing({})
        }
        setIsloader(false);
    };

    const textColor = '#AAA'

    const  handleRouterClick = (event) => {
    };

    useEffect(() => {
      if (SingleTemperatureData?.data || temperature?.data){
        setIsloader(false);
      }
    },[SingleTemperatureData,temperature]);

    useEffect(() => {
      const mappedValues = R.map(thing => ({ 'id':thing._id,value: thing.name, label: `${thing.plateNumber || 'N/A'}` }))(thingsData);
      setThings(mappedValues);
    },[thingsData]);


    useEffect(() => {
      const date = new Date();
      const startTime = moment(date)
        .hours(0)
        .minutes(0)
        .seconds(0);
      const endTime = moment(date)
        .hours(23)
        .minutes(59)
        .seconds(59);

        let imei = props.match.params.id;
        let requestData = {
          imei,
          interval:JSON.stringify({
            interval:{
              startDate :  startTime,
              endDate :  endTime
            }
          })
        };

        (async () => {
          let response = await props.actions.getDatabasedonSingleImei(requestData);
          setSelectedStartDate(startTime)
          setSelectedEndDate(endTime)
          if (response){
            setSelectedData(response)
            let mapthing = {
              '_id':response._id,
              'lat':response.lastLat,
              'lng':response.lastLng,
              'temperature':response.lastTemp,
              'temperature2':response.lastTemp2 || 0,
              'temperature3':response.lastTemp3 || 0,
              'temperature4':response.lastTemp4 || 0,
              'enableSensor2': response.enableSensor2 || false,
              'enableSensor3': response.enableSensor3 || false,
              'enableSensor4': response.enableSensor4 || false,
              'timestamp':response.timestamp,
              'humidity':response.lastHum,
              'humidity2':response.lastHum2,
              'humidity3':response.lastHum3,
              'humidity4':response.lastHum4,
              'imei':response.imei,
              'name':response.name
            };
            setMapthing(mapthing);
            setInitoading(false);
          }
        })();
      
    }, [props.match.params.id]);

    let thingsOptions = things.map((thing) => {
      return {value: thing._id, label: thing.value}
    });
    const loader = <Spinner key='1' />;
    let tminThreshold = ((30 + 70) / Math.abs(group.lowTemperatureThreshold))
    let tmaxThreshold = ((30 + 70) / Math.abs(group.highTemperatureThreshold))
    let hminThreshold = ((40 + 100) / Math.abs(group.lowHumidityThreshold))
    let hmaxThreshold = ((40 + 100) / Math.abs(group.highHumidityThreshold));
    return (
      <div>
        {
          initloading ? <div><Spinner /></div> : <div>
                  <div className="routerData">
        <div className="row" style={{ margin: '7px',    marginBottom: "20px" }}>
          <Card style={{ height: "140px" ,flexDirection: "column", minWidth: "100%" }}>
            <CardHeader style={{ width: "100%",marginBottom: "10px"}} className="f-bold">Search </CardHeader>
            <div className="searchDiv" style={{display:"flex"}} >
                <Fragment>
                <div className="col-lg-2 col-sm-2">
                    <label>Selected Device </label>
                    <h5>{mapthing?.name || ''}</h5>
                  </div>
                  <div className="col-lg-2 col-sm-2" >
                    <label>Start Date</label>
                    <DateTime value={selectedStartDate} dateFormat="DD-MM-YYYY" timeFormat="HH:mm" onChange={setSelectedStartDate} />
                  </div>
                  <div className="col-lg-2 col-sm-2" >
                    <label>End Date</label>
                    <DateTime value={selectedEndDate} dateFormat="DD-MM-YYYY" timeFormat="HH:mm" onChange={setSelectedEndDate} />
                  </div>
                  <div className="col-lg-2" style={{ padding: '25px 0 0 25px' }}>
                    <button className={`btn btn-primary search-btn  search-button`} onClick={onSubmit}>Search</button>
                  </div>
                </Fragment>
            </div>
          </Card>
        </div>

                  <div className="contentDiv">
                    <div>
                      {
                        isloader ? <div><Spinner /></div> : <div>
                                                {selectedData && selectedData.data && selectedData.data.length ? <div className="chartDiv">
                        <div  className="row" style={{justifyContent: "space-evenly"}}>

                        <Card style={{height:"390px",marginBottom:"10px",paddingBottom:"10px",display:"flex",flexDirection: "column", minWidth: "25%" }}>
                          <CardHeader style={{ width: "100%",marginBottom: "10px"}} ><span className="f-bold">Latest Update</span> <span style={{fontSize:"10px"}}>({moment(mapthing.timestamp).format("DD/MM/YYYY, h:mm a")})</span></CardHeader>
                          <div style={{display:"flex",flexDirection:"column",margin:"auto",width: "100%",justifyContent: "center",height:"50%"}}>
                            <div style={{ height:"50%",width : "90%", margin:"auto", display:"flex", flexDirection:"column",justifyContent:"center",textAlign:"center"}}>
                            
                              <span style={{width:"100%"}}>
                                Temperature
                              </span>
                              <span style={{width:"100%"}}>
                                <h1>{mapthing?.temperature?.toFixed(1) || ''}°C</h1>
                              </span>
                            </div>
                            <div style={{height:"50%",width : "90%", margin:"auto",display:"flex", flexDirection:"column",justifyContent:"center",textAlign:"center"}}>
                                <span style={{width:"100%"}}>
                                 Humidity
                                </span>
                                <span style={{width:"100%"}}>
                                  <h1>{mapthing?.humidity?.toFixed(2) || ''} %</h1>
                                </span>
                            </div>
                        </div>
                        </Card>
                        {mapthing.enableSensor2 && (
                          <Card style={{height:"390px",marginBottom:"10px",paddingBottom:"10px",display:"flex",flexDirection: "column", minWidth: "25%" }}>
                          <CardHeader style={{ width: "100%",marginBottom: "10px"}} ><span className="f-bold">Latest Update</span> <span style={{fontSize:"10px"}}>({moment(mapthing.timestamp).format("DD/MM/YYYY, h:mm a")})</span></CardHeader>
                          <div style={{display:"flex",flexDirection:"column",margin:"auto",width: "100%",justifyContent: "center",height:"50%"}}>
                            <div style={{ height:"50%",width : "90%", margin:"auto", display:"flex", flexDirection:"column",justifyContent:"center",textAlign:"center"}}>
                              {console.log("hdiewhiodhweo" , mapthing)}
                              <span style={{width:"100%"}}>
                                Temperature Sensor 2
                              </span>
                              <span style={{width:"100%"}}>
                                <h1>{mapthing?.temperature2?.toFixed(1) || ''}°C</h1>
                              </span>
                            </div>
                            <div style={{height:"50%",width : "90%", margin:"auto",display:"flex", flexDirection:"column",justifyContent:"center",textAlign:"center"}}>
                                <span style={{width:"100%"}}>
                                 Humidity Sensor 2
                                </span>
                                <span style={{width:"100%"}}>
                                  <h1>{mapthing?.humidity2?.toFixed(2) || ''} %</h1>
                                </span>
                            </div>
                        </div>
                        </Card>
                        )}
                        {mapthing.enableSensor3 && (
                          <Card style={{height:"390px",marginBottom:"10px",paddingBottom:"10px",display:"flex",flexDirection: "column", minWidth: "25%" }}>
                          <CardHeader style={{ width: "100%",marginBottom: "10px"}} ><span className="f-bold">Latest Update</span> <span style={{fontSize:"10px"}}>({moment(mapthing.timestamp).format("DD/MM/YYYY, h:mm a")})</span></CardHeader>
                          <div style={{display:"flex",flexDirection:"column",margin:"auto",width: "100%",justifyContent: "center",height:"50%"}}>
                            <div style={{ height:"50%",width : "90%", margin:"auto", display:"flex", flexDirection:"column",justifyContent:"center",textAlign:"center"}}>
                              {console.log("hdiewhiodhweo" , mapthing)}
                              <span style={{width:"100%"}}>
                                Temperature Sensor 3
                              </span>
                              <span style={{width:"100%"}}>
                                <h1>{mapthing?.temperature3?.toFixed(1) || ''}°C</h1>
                              </span>
                            </div>
                            <div style={{height:"50%",width : "90%", margin:"auto",display:"flex", flexDirection:"column",justifyContent:"center",textAlign:"center"}}>
                                <span style={{width:"100%"}}>
                                 Humidity Sensor 3
                                </span>
                                <span style={{width:"100%"}}>
                                  <h1>{mapthing?.humidity3?.toFixed(2) || ''} %</h1>
                                </span>
                            </div>
                        </div>
                        </Card>
                        )}
                        {mapthing.enableSensor4 && (
                          <Card style={{height:"390px",marginBottom:"10px",paddingBottom:"10px",display:"flex",flexDirection: "column", minWidth: "25%" }}>
                          <CardHeader style={{ width: "100%",marginBottom: "10px"}} ><span className="f-bold">Latest Update</span> <span style={{fontSize:"10px"}}>({moment(mapthing.timestamp).format("DD/MM/YYYY, h:mm a")})</span></CardHeader>
                          <div style={{display:"flex",flexDirection:"column",margin:"auto",width: "100%",justifyContent: "center",height:"50%"}}>
                            <div style={{ height:"50%",width : "90%", margin:"auto", display:"flex", flexDirection:"column",justifyContent:"center",textAlign:"center"}}>
                              {console.log("hdiewhiodhweo" , mapthing)}
                              <span style={{width:"100%"}}>
                                Temperature Sensor 4
                              </span>
                              <span style={{width:"100%"}}>
                                <h1>{mapthing?.temperature4?.toFixed(1) || ''}°C</h1>
                              </span>
                            </div>
                            <div style={{height:"50%",width : "90%", margin:"auto",display:"flex", flexDirection:"column",justifyContent:"center",textAlign:"center"}}>
                                <span style={{width:"100%"}}>
                                 Humidity Sensor 4
                                </span>
                                <span style={{width:"100%"}}>
                                  <h1>{mapthing?.humidity4?.toFixed(2) || ''} %</h1>
                                </span>
                            </div>
                        </div>
                        </Card>
                        )}
                        <Card style={{height:"390px",paddingBottom:"10px",display:"flex",flexDirection: "column", minWidth: "70%" }}>
                          <CardHeader style={{ width: "100%",marginBottom: "10px"}} className="f-bold">
                              <span style={{float:"left"}}>Temperature</span>
                              <span style={{float:"right"}}>
                                <button onClick={() => handleTemperatureDownload()} className="btn">
                                  <i className="fa fa-cloud-download" aria-hidden="true"></i>
                                </button>
                              </span>
                          </CardHeader>
                          <ResponsiveContainer width="100%" height="100%">
                            <LineChart ref={temperatureRef} width={1020} height={250} data={selectedData?.data || []} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                              <CartesianGrid strokeDasharray="3 3" />
                                <defs>
                                  <linearGradient id="gradient" x1="0" y1="1" x2="0" y2="0">
                                    <stop offset={`${tminThreshold}%`} stopColor="red" />
                                    <stop offset={`${tmaxThreshold}%`} stopColor="red" />
                                    <stop offset={`0%`} stopColor="blue" />
                                  </linearGradient>
                                </defs>
                              <XAxis onClick={handleRouterClick} interval="preserveStartEnd" dataKey="dateTime" label={{
                                value: "Date and Hour",
                                position: "insideBottomLeft",
                                offset: -6,
                                fill: "#666666",
                                fontFamily: "Roboto",
                              }} />
                              <YAxis domain={[group.tmin || -30, group.tmax || 70]} label={{
                                value: "Temperature °C",
                                angle: -90,
                                position: "left",
                                offset: -4,
                                fill: "#666666",
                                fontFamily: "Roboto"
                              }} />
                              <Tooltip />
                              <Legend />
                              {/* <Line type="monotone" dataKey="temperature" stroke="#03abce" /> */}
                              <Line type="monotone" dataKey="temperature" stroke="url(#gradient)" dot={false} />
                            </LineChart>
                          </ResponsiveContainer>
                        </Card>
                        {mapthing.enableSensor2 && (
                          <Card style={{height:"390px", marginTop:"20px" ,paddingBottom:"10px",display:"flex",flexDirection: "column", minWidth: "70%" }}>
                          <CardHeader style={{ width: "100%",marginBottom: "10px"}} className="f-bold">
                              <span style={{float:"left"}}>Temperature Sensor 2</span>
                              <span style={{float:"right"}}>
                                <button onClick={() => handleTemperatureDownload()} className="btn">
                                  <i className="fa fa-cloud-download" aria-hidden="true"></i>
                                </button>
                              </span>
                          </CardHeader>
                          <ResponsiveContainer width="100%" height="100%">
                            <LineChart ref={temperatureRef} width={1020} height={250} data={selectedData?.data || []} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                              <CartesianGrid strokeDasharray="3 3" />
                                <defs>
                                  <linearGradient id="gradient" x1="0" y1="1" x2="0" y2="0">
                                    <stop offset={`${tminThreshold}%`} stopColor="red" />
                                    <stop offset={`${tmaxThreshold}%`} stopColor="red" />
                                    <stop offset={`0%`} stopColor="blue" />
                                  </linearGradient>
                                </defs>
                              <XAxis onClick={handleRouterClick} interval="preserveStartEnd" dataKey="dateTime" label={{
                                value: "Date and Hour",
                                position: "insideBottomLeft",
                                offset: -6,
                                fill: "#666666",
                                fontFamily: "Roboto",
                              }} />
                              <YAxis domain={[group.tmin || -30, group.tmax || 70]} label={{
                                value: "Temperature °C",
                                angle: -90,
                                position: "left",
                                offset: -4,
                                fill: "#666666",
                                fontFamily: "Roboto"
                              }} />
                              <Tooltip />
                              <Legend />
                              {/* <Line type="monotone" dataKey="temperature" stroke="#03abce" /> */}
                              <Line type="monotone" dataKey="temperature2" stroke="url(#gradient)" dot={false} />
                            </LineChart>
                          </ResponsiveContainer>
                        </Card>
                        )}
                        {mapthing.enableSensor3 && (
                          <Card style={{height:"390px", marginTop:"20px" ,paddingBottom:"10px",display:"flex",flexDirection: "column", minWidth: "70%" }}>
                          <CardHeader style={{ width: "100%",marginBottom: "10px"}} className="f-bold">
                              <span style={{float:"left"}}>Temperature Sensor 3</span>
                              <span style={{float:"right"}}>
                                <button onClick={() => handleTemperatureDownload()} className="btn">
                                  <i className="fa fa-cloud-download" aria-hidden="true"></i>
                                </button>
                              </span>
                          </CardHeader>
                          <ResponsiveContainer width="100%" height="100%">
                            <LineChart ref={temperatureRef} width={1020} height={250} data={selectedData?.data || []} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                              <CartesianGrid strokeDasharray="3 3" />
                                <defs>
                                  <linearGradient id="gradient" x1="0" y1="1" x2="0" y2="0">
                                    <stop offset={`${tminThreshold}%`} stopColor="red" />
                                    <stop offset={`${tmaxThreshold}%`} stopColor="red" />
                                    <stop offset={`0%`} stopColor="blue" />
                                  </linearGradient>
                                </defs>
                              <XAxis onClick={handleRouterClick} interval="preserveStartEnd" dataKey="dateTime" label={{
                                value: "Date and Hour",
                                position: "insideBottomLeft",
                                offset: -6,
                                fill: "#666666",
                                fontFamily: "Roboto",
                              }} />
                              <YAxis domain={[group.tmin || -30, group.tmax || 70]} label={{
                                value: "Temperature °C",
                                angle: -90,
                                position: "left",
                                offset: -4,
                                fill: "#666666",
                                fontFamily: "Roboto"
                              }} />
                              <Tooltip />
                              <Legend />
                              {/* <Line type="monotone" dataKey="temperature" stroke="#03abce" /> */}
                              <Line type="monotone" dataKey="temperature3" stroke="url(#gradient)" dot={false} />
                            </LineChart>
                          </ResponsiveContainer>
                        </Card>
                        )}
                        {mapthing.enableSensor4 && (
                          <Card style={{height:"390px", marginTop:"20px" , paddingBottom:"10px",display:"flex",flexDirection: "column", minWidth: "70%" }}>
                          <CardHeader style={{ width: "100%",marginBottom: "10px"}} className="f-bold">
                              <span style={{float:"left"}}>Temperature Sensor 4</span>
                              <span style={{float:"right"}}>
                                <button onClick={() => handleTemperatureDownload()} className="btn">
                                  <i className="fa fa-cloud-download" aria-hidden="true"></i>
                                </button>
                              </span>
                          </CardHeader>
                          <ResponsiveContainer width="100%" height="100%">
                            <LineChart ref={temperatureRef} width={1020} height={250} data={selectedData?.data || []} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                              <CartesianGrid strokeDasharray="3 3" />
                                <defs>
                                  <linearGradient id="gradient" x1="0" y1="1" x2="0" y2="0">
                                    <stop offset={`${tminThreshold}%`} stopColor="red" />
                                    <stop offset={`${tmaxThreshold}%`} stopColor="red" />
                                    <stop offset={`0%`} stopColor="blue" />
                                  </linearGradient>
                                </defs>
                              <XAxis onClick={handleRouterClick} interval="preserveStartEnd" dataKey="dateTime" label={{
                                value: "Date and Hour",
                                position: "insideBottomLeft",
                                offset: -6,
                                fill: "#666666",
                                fontFamily: "Roboto",
                              }} />
                              <YAxis domain={[group.tmin || -30, group.tmax || 70]} label={{
                                value: "Temperature °C",
                                angle: -90,
                                position: "left",
                                offset: -4,
                                fill: "#666666",
                                fontFamily: "Roboto"
                              }} />
                              <Tooltip />
                              <Legend />
                              {/* <Line type="monotone" dataKey="temperature" stroke="#03abce" /> */}
                              <Line type="monotone" dataKey="temperature4" stroke="url(#gradient)" dot={false} />
                            </LineChart>
                          </ResponsiveContainer>
                        </Card>
                        )}
                        </div>
                        <div  className="row" style={{justifyContent: "space-evenly"}}>
                        <Card style={{height:"390px" , marginTop:"20px",marginBottom:"10px",paddingBottom:"10px",display:"flex",flexDirection: "column", minWidth: "25%" }}>
                          <CardHeader style={{ width: "100%",marginBottom: "10px"}} className="f-bold">Location</CardHeader>
                          <div className="row" style={{overflowY:"scroll",display:"flex",flexDirection:"column",margin:"auto",width: "100%",justifyContent: "center"}}>
                            <div style={{width : "90%", margin:"auto"}}>
                              {mapthing && mapthing.lat && <MapWithAMarkerClusterer
                                  markers={[mapthing] }
                                  smoothCall={false}
                                  zoom={10}
                                  center={{
                                    lat: mapthing.lat,
                                    lng: mapthing.lng,
                                  }}
                                  defaultCenter={{
                                    lat: mapthing.lat,
                                    lng: mapthing.lng,
                                  }}
                                />}
                            
                            </div>
                        </div>
                        </Card>
                        <Card style={{height:"390px", marginTop:"20px" , paddingBottom:"10px",display:"flex",flexDirection: "column", minWidth: "70%" }}>
                        <CardHeader style={{ width: "100%",marginBottom: "10px"}} className="f-bold">
                          <span style={{float:"left"}}>Humidity</span>
                          <span style={{float:"right"}}>
                            <button onClick={() => handleHumidityDownload()} className="btn">
                              <i className="fa fa-cloud-download" aria-hidden="true"></i>
                            </button>
                          </span>
                        </CardHeader>
                          <ResponsiveContainer width="100%" height="100%">
                            <LineChart ref={humidityRef} width={1020} hei
                            ght={250} data={selectedData?.data || []} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                              <CartesianGrid strokeDasharray="3 3" />
                              <defs>
                                  <linearGradient id="gradient" x1="0" y1="1" x2="0" y2="0">
                                    <stop offset={`${hminThreshold}%`} stopColor="red" />
                                    <stop offset={`${hmaxThreshold}%`} stopColor="red" />
                                    <stop offset={`0%`} stopColor="blue" />
                                  </linearGradient>
                                </defs>
                              <XAxis onClick={handleRouterClick} interval="preserveStartEnd" dataKey="dateTime" label={{
                                value: "Date and Hour",
                                position: "insideBottomLeft",
                                offset: -6,
                                fill: "#666666",
                                fontFamily: "Roboto",
                              }} />
                              <YAxis domain={[group.hmin || -40, group.hmax || 100]} label={{
                                value: "Humidity %",
                                angle: -90,
                                position: "left",
                                offset: -4,
                                fill: "#666666",
                                fontFamily: "Roboto"
                              }} />
                              <Tooltip />
                              <Legend />
                              {/* <Line type="monotone" dataKey="humidity" stroke="#03abce" /> */}
                              <Line type="monotone" dataKey="humidity" stroke="url(#gradient)" dot={false} />
                            </LineChart>
                          </ResponsiveContainer>
                        </Card>
                        {mapthing.enableSensor2 && (
                          <Card style={{height:"390px", marginTop:"20px" , marginTop:"20px" ,paddingBottom:"10px",display:"flex",flexDirection: "column" , minWidth: "70%" }}>
                        <CardHeader style={{ width: "100%",marginBottom: "10px"}} className="f-bold">
                          <span style={{float:"left"}}>Humidity Sensor 2</span>
                          <span style={{float:"right"}}>
                            <button onClick={() => handleHumidityDownload()} className="btn">
                              <i className="fa fa-cloud-download" aria-hidden="true"></i>
                            </button>
                          </span>
                        </CardHeader>
                          <ResponsiveContainer width="100%" height="100%">
                            <LineChart ref={humidityRef} width={1020} hei
                            ght={250} data={selectedData?.data || []} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                              <CartesianGrid strokeDasharray="3 3" />
                              <defs>
                                  <linearGradient id="gradient" x1="0" y1="1" x2="0" y2="0">
                                    <stop offset={`${hminThreshold}%`} stopColor="red" />
                                    <stop offset={`${hmaxThreshold}%`} stopColor="red" />
                                    <stop offset={`0%`} stopColor="blue" />
                                  </linearGradient>
                                </defs>
                              <XAxis onClick={handleRouterClick} interval="preserveStartEnd" dataKey="dateTime" label={{
                                value: "Date and Hour",
                                position: "insideBottomLeft",
                                offset: -6,
                                fill: "#666666",
                                fontFamily: "Roboto",
                              }} />
                              <YAxis domain={[group.hmin || -40, group.hmax || 100]} label={{
                                value: "Humidity %",
                                angle: -90,
                                position: "left",
                                offset: -4,
                                fill: "#666666",
                                fontFamily: "Roboto"
                              }} />
                              <Tooltip />
                              <Legend />
                              {/* <Line type="monotone" dataKey="humidity" stroke="#03abce" /> */}
                              <Line type="monotone" dataKey="humidity2" stroke="url(#gradient)" dot={false} />
                            </LineChart>
                          </ResponsiveContainer>
                        </Card>
                        )}
                        {mapthing.enableSensor3 && (
                          <Card style={{height:"390px", marginTop:"20px", paddingBottom:"10px",display:"flex",flexDirection: "column", minWidth: "70%" }}>
                        <CardHeader style={{ width: "100%",marginBottom: "10px"}} className="f-bold">
                          <span style={{float:"left"}}>Humidity Sensor 3</span>
                          <span style={{float:"right"}}>
                            <button onClick={() => handleHumidityDownload()} className="btn">
                              <i className="fa fa-cloud-download" aria-hidden="true"></i>
                            </button>
                          </span>
                        </CardHeader>
                          <ResponsiveContainer width="100%" height="100%">
                            <LineChart ref={humidityRef} width={1020} hei
                            ght={250} data={selectedData?.data || []} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                              <CartesianGrid strokeDasharray="3 3" />
                              <defs>
                                  <linearGradient id="gradient" x1="0" y1="1" x2="0" y2="0">
                                    <stop offset={`${hminThreshold}%`} stopColor="red" />
                                    <stop offset={`${hmaxThreshold}%`} stopColor="red" />
                                    <stop offset={`0%`} stopColor="blue" />
                                  </linearGradient>
                                </defs>
                              <XAxis onClick={handleRouterClick} interval="preserveStartEnd" dataKey="dateTime" label={{
                                value: "Date and Hour",
                                position: "insideBottomLeft",
                                offset: -6,
                                fill: "#666666",
                                fontFamily: "Roboto",
                              }} />
                              <YAxis domain={[group.hmin || -40, group.hmax || 100]} label={{
                                value: "Humidity %",
                                angle: -90,
                                position: "left",
                                offset: -4,
                                fill: "#666666",
                                fontFamily: "Roboto"
                              }} />
                              <Tooltip />
                              <Legend />
                              {/* <Line type="monotone" dataKey="humidity" stroke="#03abce" /> */}
                              <Line type="monotone" dataKey="humidity3" stroke="url(#gradient)" dot={false} />
                            </LineChart>
                          </ResponsiveContainer>
                        </Card>
                        )}
                        {mapthing.enableSensor4 && (
                          <Card style={{height:"390px", marginTop:"20px" , paddingBottom:"10px",display:"flex",flexDirection: "column", minWidth: "70%" }}>
                        <CardHeader style={{ width: "100%",marginBottom: "10px"}} className="f-bold">
                          <span style={{float:"left"}}>Humidity Sensor 4</span>
                          <span style={{float:"right"}}>
                            <button onClick={() => handleHumidityDownload()} className="btn">
                              <i className="fa fa-cloud-download" aria-hidden="true"></i>
                            </button>
                          </span>
                        </CardHeader>
                          <ResponsiveContainer width="100%" height="100%">
                            <LineChart ref={humidityRef} width={1020} hei
                            ght={250} data={selectedData?.data || []} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                              <CartesianGrid strokeDasharray="3 3" />
                              <defs>
                                  <linearGradient id="gradient" x1="0" y1="1" x2="0" y2="0">
                                    <stop offset={`${hminThreshold}%`} stopColor="red" />
                                    <stop offset={`${hmaxThreshold}%`} stopColor="red" />
                                    <stop offset={`0%`} stopColor="blue" />
                                  </linearGradient>
                                </defs>
                              <XAxis onClick={handleRouterClick} interval="preserveStartEnd" dataKey="dateTime" label={{
                                value: "Date and Hour",
                                position: "insideBottomLeft",
                                offset: -6,
                                fill: "#666666",
                                fontFamily: "Roboto",
                              }} />
                              <YAxis domain={[group.hmin || -40, group.hmax || 100]} label={{
                                value: "Humidity %",
                                angle: -90,
                                position: "left",
                                offset: -4,
                                fill: "#666666",
                                fontFamily: "Roboto"
                              }} />
                              <Tooltip />
                              <Legend />
                              {/* <Line type="monotone" dataKey="humidity" stroke="#03abce" /> */}
                              <Line type="monotone" dataKey="humidity4" stroke="url(#gradient)" dot={false} />
                            </LineChart>
                          </ResponsiveContainer>
                        </Card>
                        )}
                        </div>
                      </div> : (<div style={{ margin: '7px',    marginBottom: "20px" }}>There is no data</div>)}
                        </div>
                      }
                      
                      </div>
                </div>
      </div>    
          </div>
        }
      </div>

    );
}

const mapStateToProps = (state) => {
  return {
    things: state.things.groupVehicles,
    storeSelectedThing: state.things.selectedThing,
    temperature: state?.things?.chartsData,
    group: state.groups.group
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(Things.creators, dispatch),
  groupActions: bindActionCreators(Groups.creators, dispatch),
});
export default connect(mapStateToProps, mapDispatchToProps)(Temperature);
